import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React from "react";

import { formatCellValue } from "./weeklyEACFormat";

const META_FIELDS = [
  { key: "projectName", label: "Project Name" },
  { key: "startDate", label: "Start Date", format: "date" },
  { key: "endDate", label: "End Date", format: "date" },
  { key: "totalClinValue", label: "Total CLIN Value", format: "currency" },
  { key: "totalFundingValue", label: "Total Funding Value", format: "currency" },
];

const tableTitleStyle = {
  fontSize: "15px",
  color: "#ffffff",
  backgroundColor: "#01539a",
  lineHeight: "1",
};

const cellStyle = { padding: "4px 8px", lineHeight: "1.2", verticalAlign: "bottom" };

const chunkIntoPairs = (fields) => {
  const rows = [];
  for (let i = 0; i < fields.length; i += 2) {
    rows.push([fields[i], fields[i + 1]]);
  }
  return rows;
};

export default function WeeklyEACMeta({ clinDetails = {} }) {
  const rows = chunkIntoPairs(META_FIELDS);

  return (
    <TableContainer style={{ marginTop: "16px" }}>
      <Table className="contractSummaryTable" style={{ width: "100%", tableLayout: "fixed" }}>
        <TableHead>
          <TableRow>
            <TableCell colSpan={4} style={tableTitleStyle}>
              CLIN Details
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((pair, rowIndex) => (
            <TableRow key={rowIndex} style={{ height: 30 }}>
              {pair.map((field, cellIndex) =>
                field ? (
                  <React.Fragment key={field.key}>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ ...cellStyle, width: "15%" }}
                    >
                      {field.label}
                    </TableCell>
                    <TableCell style={{ ...cellStyle, width: "35%" }}>
                      {formatCellValue(clinDetails[field.key], field.format)}
                    </TableCell>
                  </React.Fragment>
                ) : (
                  <React.Fragment key={`empty-${cellIndex}`}>
                    <TableCell style={{ ...cellStyle, width: "15%" }} />
                    <TableCell style={{ ...cellStyle, width: "35%" }} />
                  </React.Fragment>
                ),
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
